import { select, put, takeLatest } from 'redux-saga/effects';
import { UserMessage, ConversationAPI } from 'api/conversations';
import { StoreActionProps } from 'data/core';
import { logger } from 'services';
import { deleteCommentAction } from '../actions';
import { selectConversation } from '../selectors';
import { createComment, deleteComment } from '../slices';
import { CommentActionPayload } from '../types';

function* deleteCommentSaga(
  action: StoreActionProps<CommentActionPayload<UserMessage>>,
) {
  const { comment, context } = action.payload;

  const { projectId } = yield select(selectConversation(context));

  try {
    yield put(
      deleteComment({
        comment,
        context,
      }),
    );
    yield ConversationAPI.deleteComment(projectId, context, comment.commentId);
  } catch (error) {
    logger.error('deleteComment failed', { error });

    yield put(
      createComment({
        comment,
        context,
      }),
    );
  }
}

export const watchDeleteCommentSaga = function* (): Generator {
  yield takeLatest(deleteCommentAction.type, deleteCommentSaga);
};
